// main.ts

import { mountImageComposer } from './library'

// 1. Store results in memory so they persist even if Knockout deletes the script tag
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let cachedResults: any = null

function autoMount() {
  const targetSelector = '#share-image'
  const host = document.querySelector(targetSelector) as HTMLElement

  if (!host) return

  // 2. IDEMPOTENCY: Stop if already mounted to avoid flickering or loops
  if (host.querySelector('wmm-image-composer')) {
    return
  }

  // 3. DATA RECOVERY: Try to get fresh data, otherwise use the cache
  const dataElement = document.getElementById('wmm-results-data')

  if (dataElement) {
    try {
      const freshResults = JSON.parse(dataElement.textContent || '')
      if (freshResults) cachedResults = freshResults
    } catch (e) {
      console.error('WMM Extension: Failed to parse results JSON', e)
    }
  }

  // 4. MOUNT: Use whichever data we have available
  if (cachedResults) {
    console.log('WMM Extension: Mounting/Re-mounting component...')
    mountImageComposer(targetSelector, cachedResults)
  } else {
    console.warn('WMM Extension: Target found, but no results data available (cache empty).')
  }
}

/**
 * Persists the component by watching for DOM changes.
 * Essential for host sites using Knockout.js or React.
 */
function setupPersistence() {
  const targetSelector = '#share-image'

  const observer = new MutationObserver((mutations) => {
    let needsCheck = false

    for (const mutation of mutations) {
      // If nodes were added, check if our target is among them
      if (mutation.addedNodes.length > 0) {
        needsCheck = true
        break
      }

      // If nodes were removed, check if it was our host
      mutation.removedNodes.forEach((node) => {
        if (
          node instanceof HTMLElement &&
          (node.id === 'share-image' || node.querySelector(targetSelector))
        ) {
          console.log('WMM Extension: Mount point removed by host. Waiting for recreation...')
          needsCheck = true
        }
      })
    }

    if (needsCheck) {
      autoMount()
    }
  })

  // Observe the body to survive container swaps
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}

// Start everything
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    autoMount()
    setupPersistence()
  })
} else {
  autoMount()
  setupPersistence()
}
